(function(){
  const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Loader */
  const finChargement = () => {
    document.getElementById('loader').classList.add('done');
    document.body.classList.add('monte'); // déclenche l'assemblage du sigle
  };
  addEventListener('load', () => setTimeout(finChargement, prefersReduced ? 0 : 900));
  setTimeout(finChargement, 2600); // sécurité

  /* Nav au scroll */
  const nav = document.getElementById('nav');
  addEventListener('scroll', () => nav.classList.toggle('scrolled', scrollY > 40), {passive:true});

  /* Menu mobile : tiroir latéral gauche */
  (function(){
    const burger = document.getElementById('navBurger');
    const tiroir = document.getElementById('menuMobile');
    const voile  = document.getElementById('menuVoile');
    if (!burger || !tiroir || !voile) return;
    const btnFermer = document.getElementById('menuFermer');
    const mqMobile  = matchMedia('(max-width:680px)');
    let ouvert = false, avantFocus = null, scrollMem = 0, tVoile = null;

    const cibles = () => Array.from(tiroir.querySelectorAll('a[href],button:not([disabled])'))
                              .filter(el => el.offsetParent !== null);

    /* Verrou de défilement : sur iOS, overflow:hidden sur <body> ne suffit pas.
       On fige le corps en position:fixed et on restitue la position au retour. */
    function verrouille(){
      scrollMem = scrollY || document.documentElement.scrollTop || 0;
      document.documentElement.style.setProperty('--scroll-y', scrollMem + 'px');
      document.documentElement.classList.add('menu-ouvert');
      document.body.classList.add('menu-ouvert');
    }
    function deverrouille(){
      if (!document.body.classList.contains('menu-ouvert')) return;
      document.documentElement.classList.remove('menu-ouvert');
      document.body.classList.remove('menu-ouvert');
      document.documentElement.style.removeProperty('--scroll-y');
      // Restitution sans animation, sinon scroll-behavior:smooth rejoue tout le défilement
      document.documentElement.style.scrollBehavior = 'auto';
      scrollTo(0, scrollMem);
      document.documentElement.style.removeProperty('scroll-behavior');
    }

    function ouvre(){
      if (ouvert || !mqMobile.matches) return;
      ouvert = true;
      avantFocus = document.activeElement;
      clearTimeout(tVoile);
      voile.hidden = false;
      // Double rAF : garantit le calcul du style initial avant la transition
      requestAnimationFrame(() => requestAnimationFrame(() => voile.classList.add('on')));
      tiroir.classList.add('on');
      burger.classList.add('on');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Fermer le menu');
      tiroir.setAttribute('aria-hidden', 'false');
      tiroir.removeAttribute('inert');
      verrouille();
      const f = cibles();
      if (f.length) setTimeout(() => { if (ouvert) f[0].focus({preventScroll:true}); }, prefersReduced ? 0 : 280);
    }

    function ferme(rendreFocus){
      if (!ouvert) return;
      ouvert = false;
      tiroir.classList.remove('on');
      voile.classList.remove('on');
      burger.classList.remove('on');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Ouvrir le menu');
      tiroir.setAttribute('aria-hidden', 'true');
      // Le focus doit sortir du tiroir AVANT inert, sinon il est perdu
      if (rendreFocus !== false) {
        const el = (avantFocus && document.contains(avantFocus)) ? avantFocus : burger;
        el.focus({preventScroll:true});
      } else if (tiroir.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      tiroir.setAttribute('inert', '');
      deverrouille();
      clearTimeout(tVoile);
      tVoile = setTimeout(() => { if (!ouvert) voile.hidden = true; }, 500);
    }

    burger.addEventListener('click', () => ouvert ? ferme() : ouvre());
    voile.addEventListener('click', () => ferme());
    if (btnFermer) btnFermer.addEventListener('click', () => ferme());

    /* Un lien ferme le tiroir. Pour une ancre de la page courante, on rend la main
       au navigateur APRÈS avoir restitué le défilement, sinon la cible est ratée. */
    tiroir.querySelectorAll('a[href]').forEach(a => {
      a.addEventListener('click', e => {
        const url = new URL(a.href, location.href);
        const ancre = url.hash && url.pathname === location.pathname && url.search === location.search;
        ferme(false);
        if (ancre) {
          e.preventDefault();
          const cible = document.getElementById(url.hash.slice(1));
          if (cible) {
            history.pushState(null, '', url.hash);
            cible.scrollIntoView({behavior: prefersReduced ? 'auto' : 'smooth', block:'start'});
          } else {
            location.href = a.href; // l'ancre est sur une autre page
          }
        }
      });
    });

    addEventListener('keydown', e => {
      if (!ouvert) return;
      if (e.key === 'Escape'){ e.preventDefault(); ferme(); return; }
      if (e.key === 'Tab'){
        const f = cibles();
        if (!f.length) return;
        const premier = f[0], dernier = f[f.length - 1];
        if (!tiroir.contains(document.activeElement)){ e.preventDefault(); premier.focus(); return; }
        if (e.shiftKey && document.activeElement === premier){ e.preventDefault(); dernier.focus(); }
        else if (!e.shiftKey && document.activeElement === dernier){ e.preventDefault(); premier.focus(); }
      }
    });

    /* Passage en desktop : matchMedia plutôt que resize (la barre d'URL mobile
       déclenche des resize parasites en permanence) */
    const surChangement = e => { if (!e.matches) ferme(false); };
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', surChangement);
    else mqMobile.addListener(surChangement);

    /* Retour arrière depuis le cache navigateur : on repart toujours fermé */
    addEventListener('pageshow', e => { if (e.persisted) ferme(false); });

    /* Glissé vers la gauche pour fermer */
    let tx = 0, ty = 0, suivi = false;
    tiroir.addEventListener('touchstart', e => {
      if (e.touches.length !== 1) { suivi = false; return; }
      suivi = true;
      tx = e.touches[0].clientX; ty = e.touches[0].clientY;
    }, {passive:true});
    tiroir.addEventListener('touchend', e => {
      if (!suivi) return;
      suivi = false;
      const dx = e.changedTouches[0].clientX - tx;
      const dy = e.changedTouches[0].clientY - ty;
      if (dx < -55 && Math.abs(dy) < 45) ferme(false);
    }, {passive:true});
  })();

  /* Compteurs de panier (nav + tiroir) : un seul point de mise à jour */
  window.majCompteurPanier = function(n){
    document.querySelectorAll('[data-panier-compte]').forEach(el => {
      el.textContent = n;
      el.classList.toggle('on', n > 0);
    });
  };

  /* --- Blocs propres à la page d'accueil --- */
  if (document.getElementById('marquee')) {
  /* Marquee : boucle infinie sans saut (clonage exact + largeur mesurée) */
  const mq = document.getElementById('marquee');
  const mqGroupe = mq.querySelector('.marquee-group');
  const construireMarquee = () => {
    mq.querySelectorAll('.marquee-group:not(:first-child)').forEach(g => g.remove());
    const largeur = mqGroupe.scrollWidth;
    if (!largeur) return;
    // Assez de copies pour couvrir 2x l'écran, quel que soit l'appareil
    const copies = Math.max(1, Math.ceil((innerWidth * 2) / largeur));
    for (let i = 0; i < copies; i++) mq.appendChild(mqGroupe.cloneNode(true));
    mq.style.setProperty('--mq-largeur', largeur + 'px');
    mq.style.setProperty('--mq-duree', Math.round(largeur / 38) + 's'); // vitesse constante
  };
  construireMarquee();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(construireMarquee);
  let mqTimer;
  addEventListener('resize', () => { clearTimeout(mqTimer); mqTimer = setTimeout(construireMarquee, 200); }, {passive:true});

  /* Révélations au scroll */
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('vu'); io.unobserve(e.target);} });
  }, {threshold:.15});
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  /* Compteurs animés */
  function anime(el, cible, duree){
    if(prefersReduced){ el.textContent = cible.toLocaleString('fr-FR'); return; }
    const t0 = performance.now();
    (function tick(t){
      const p = Math.min((t-t0)/duree, 1);
      const eased = 1 - Math.pow(1-p, 3);
      el.textContent = Math.round(cible*eased).toLocaleString('fr-FR');
      if(p<1) requestAnimationFrame(tick);
    })(t0);
  }
  const ioNum = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if(!e.isIntersecting) return;
      anime(e.target, parseInt(e.target.dataset.cible,10), 1800);
      ioNum.unobserve(e.target);
    });
  }, {threshold:.5});
  document.querySelectorAll('.val[data-cible]').forEach(el => ioNum.observe(el));

  /* Parallaxe de la section scène */
  const sceneImg = document.getElementById('sceneImg');
  const sceneWrap = document.getElementById('scene');
  if(!prefersReduced){
    addEventListener('scroll', () => {
      const r = sceneWrap.getBoundingClientRect();
      if(r.bottom < 0 || r.top > innerHeight) return;
      const p = (innerHeight - r.top) / (innerHeight + r.height); // 0..1
      sceneImg.style.transform = `translateY(${(p - .5) * 12}%)`;
    }, {passive:true});
  }

  /* Tilt 3D sur la vitrine */
  const vit = document.getElementById('vitrine');
  if(!prefersReduced){
    vit.addEventListener('mousemove', e => {
      // Ne pas incliner tout le bloc pendant que l'utilisateur manipule le modèle 3D.
      if (vit.querySelector('.diapo-item.on[data-type="model"]')) {
        vit.style.transform = 'perspective(900px) rotateY(0) rotateX(0)';
        return;
      }
      const r = vit.getBoundingClientRect();
      const x = (e.clientX - r.left)/r.width - .5;
      const y = (e.clientY - r.top)/r.height - .5;
      vit.style.transform = `perspective(900px) rotateY(${x*6}deg) rotateX(${-y*6}deg)`;
    });
    vit.addEventListener('mouseleave', () => vit.style.transform = 'perspective(900px) rotateY(0) rotateX(0)');
  }

  /* Diaporama : photos 5 s, vidéos jusqu'à leur fin, sans contrôles */
  const diapo = document.getElementById('diapo');
  if (diapo && diapo.querySelectorAll('.diapo-item').length > 1) {
    const items = Array.from(diapo.querySelectorAll('.diapo-item'));
    const pts = document.getElementById('diapoPoints');
    let cur = 0, timer = null, finVideo = null;

    // Aucune interface de lecture, et lecture forcée en place (jamais de plein écran ni de saut de page)
    diapo.querySelectorAll('video').forEach(v => {
      v.removeAttribute('controls');
      v.removeAttribute('autoplay');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.muted = true;
    });

    function pauseVideo(item){
      const v = item.querySelector('video');
      if (v) { v.pause(); }
      const f = item.querySelector('iframe');
      if (f && f.src) { const s = f.src; f.src = s; } // stoppe YouTube/Vimeo en rechargeant l'iframe
    }
    function playVideo(item){
      const v = item.querySelector('video');
      if (!v || prefersReduced) return;
      if (v.ended) v.currentTime = 0; // revenir au début si la vidéo a déjà été jouée
      // iOS/Android : les attributs doivent être présents avant play()
      v.muted = true; v.setAttribute('muted', '');
      v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      const p = v.play();
      if (p && p.catch) p.catch(() => {
        // Données pas encore chargées (preload metadata) : on force le chargement puis on réessaie
        v.addEventListener('loadeddata', () => { v.play().catch(() => {}); }, { once: true });
        try { v.load(); } catch (e) {}
        // Dernier filet : lecture au premier toucher de l'utilisateur
        document.addEventListener('touchstart', () => { v.play().catch(() => {}); }, { once: true, passive: true });
      });
    }
    function montre(i){
      pauseVideo(items[cur]);
      items[cur].classList.remove('on'); pts.children[cur].classList.remove('on');
      cur = (i + items.length) % items.length;
      items[cur].classList.add('on'); pts.children[cur].classList.add('on');
      playVideo(items[cur]);
    }
    function annule(){
      clearTimeout(timer);
      if (finVideo) { finVideo.el.removeEventListener('ended', finVideo.fn); finVideo = null; }
    }
    function relance(){
      annule();
      if (prefersReduced || !galerieVisible) return;
      const item = items[cur];
      const v = item.querySelector('video');
      if (item.dataset.type === 'video' && v) {
        // Vidéo : on passe à la suivante quand elle est terminée
        const fn = () => { montre(cur + 1); relance(); };
        v.addEventListener('ended', fn, { once: true });
        finVideo = { el: v, fn };
      } else if (item.dataset.type === 'model') {
        // Vue 3D interactive : on ne change jamais de média automatiquement pendant la manipulation.
        return;
      } else {
        // Photo : 5 s — vidéo externe : 8 s.
        const duree = item.dataset.type === 'image' ? 5000 : 8000;
        timer = setTimeout(() => { montre(cur + 1); relance(); }, duree);
      }
    }
    items.forEach((it, i) => {
      const b = document.createElement('button');
      const libelleMedia = it.dataset.type === 'image' ? 'Photo ' : (it.dataset.type === 'model' ? 'Vue 3D ' : 'Vidéo ');
      b.setAttribute('aria-label', libelleMedia + (i + 1));
      if (it.dataset.type === 'model') b.classList.add('modele-3d');
      else if (it.dataset.type !== 'image') b.classList.add('video');
      if (i === 0) b.classList.add('on');
      b.addEventListener('click', () => { montre(i); relance(); });
      pts.appendChild(b);
    });
    document.getElementById('diapoPrec').addEventListener('click', () => { montre(cur - 1); relance(); });
    document.getElementById('diapoSuiv').addEventListener('click', () => { montre(cur + 1); relance(); });

    // Mobile : swipe horizontal sur les médias (on laisse la vue 3D gérer ses propres gestes).
    let touchStartX = 0, touchStartY = 0, touchActive = false;
    diapo.addEventListener('touchstart', e => {
      if (e.touches.length !== 1) { touchActive = false; return; }
      const actif = items[cur];
      if ((actif && actif.dataset.type === 'model') || e.target.closest('model-viewer')) { touchActive = false; return; }
      const t = e.touches[0];
      touchStartX = t.clientX; touchStartY = t.clientY; touchActive = true;
    }, { passive:true });
    diapo.addEventListener('touchend', e => {
      if (!touchActive || !e.changedTouches.length) return;
      touchActive = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - touchStartX, dy = t.clientY - touchStartY;
      if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;
      e.preventDefault();
      window.__gallerySwipedUntil = Date.now() + 650;
      montre(cur + (dx < 0 ? 1 : -1));
      relance();
    }, { passive:false });
    diapo.querySelectorAll('model-viewer').forEach(model => {
      const stopAuto = () => annule();
      model.addEventListener('pointerdown', stopAuto, { passive: true });
      model.addEventListener('touchstart', stopAuto, { passive: true });
    });
    // La vidéo et le défilement ne démarrent que lorsque le visiteur arrive de lui-même
    // devant la galerie ; rien ne se lance (et rien ne bouge) tant qu'elle est hors écran.
    let galerieVisible = false;
    const ioGalerie = new IntersectionObserver(entries => {
      entries.forEach(e => {
        galerieVisible = e.isIntersecting;
        if (galerieVisible) { playVideo(items[cur]); relance(); }
        else { annule(); pauseVideo(items[cur]); }
      });
    }, { threshold: .3 });
    ioGalerie.observe(diapo);
  }

  /* Panier Shopify (AJAX) — aucune limite de quantité par personne */
  const formAchat = document.getElementById('achatForm');
  const btnAdd = document.getElementById('ajouter');
  // Précommande pas encore ouverte : le formulaire reste inerte jusqu'à l'heure dite
  if (formAchat && formAchat.dataset.verrouille === '1') {
    formAchat.addEventListener('submit', e => e.preventDefault());
  }
  if (formAchat && btnAdd && !btnAdd.disabled && formAchat.dataset.verrouille !== '1') {
    const PRIX = parseFloat(btnAdd.dataset.prix) || 239.99;
    // Libellé piloté par le thème : « Ajouter au panier » ou « Précommander »
    const LIBELLE = formAchat.dataset.libelle || 'Ajouter au panier';
    const qte = document.getElementById('qte');
    const majBtn = () => {
      const n = qte ? +qte.value : 1;
      btnAdd.textContent = `${LIBELLE} — ${(PRIX * n).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
    };
    if (qte) {
      document.getElementById('plus').addEventListener('click', () => { qte.value = +qte.value + 1; majBtn(); });
      document.getElementById('moins').addEventListener('click', () => { qte.value = Math.max(1, +qte.value - 1); majBtn(); });
    }
    formAchat.addEventListener('submit', e => {
      e.preventDefault();
      btnAdd.disabled = true;
      const fd = new FormData(formAchat);
      fd.set('quantity', Math.max(1, qte ? +qte.value : 1));
      fetch(formAchat.action + '.js', { method:'POST', headers:{ 'Accept':'application/json' }, body:fd })
        .then(r => { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(() => {
          // Redirection immédiate vers le panier après l'ajout
          btnAdd.classList.add('ok'); btnAdd.textContent = '✓ Ajouté';
          window.location.href = formAchat.dataset.cartUrl || '/cart';
        })
        .catch(() => { btnAdd.disabled = false; });
    });
  }


  } // fin blocs accueil

  /* FAQ accordéon */
  document.querySelectorAll('.faq-q').forEach(q => q.addEventListener('click', () => {
    const item = q.parentElement, r = item.querySelector('.faq-r');
    const ouvert = item.classList.contains('ouvert');
    document.querySelectorAll('.faq-item').forEach(i => { i.classList.remove('ouvert'); i.querySelector('.faq-r').style.maxHeight = null; });
    if(!ouvert){ item.classList.add('ouvert'); r.style.maxHeight = r.scrollHeight + 'px'; }
  }));

  /* Visionneuse plein écran : clic sur une image produit + swipe entre les images */
  (function(){
    const sources = ['#diapo', '#ppScene'].map(s => document.querySelector(s)).filter(Boolean);
    if (!sources.length) return;

    const vis = document.createElement('div');
    vis.id = 'visionneuse';
    vis.setAttribute('role', 'dialog');
    vis.setAttribute('aria-modal', 'true');
    vis.setAttribute('aria-label', 'Photos du produit en plein écran');
    vis.innerHTML = `
      <button class="vis-fermer" type="button" aria-label="Fermer">&times;</button>
      <button class="vis-fleche vis-prec" type="button" aria-label="Photo précédente">‹</button>
      <div class="vis-contenu"></div>
      <button class="vis-fleche vis-suiv" type="button" aria-label="Photo suivante">›</button>
      <div class="vis-points" aria-hidden="true"></div>`;
    document.body.appendChild(vis);

    const contenu = vis.querySelector('.vis-contenu');
    const btnPrec = vis.querySelector('.vis-prec');
    const btnSuiv = vis.querySelector('.vis-suiv');
    const points = vis.querySelector('.vis-points');
    let images = [];
    let index = 0;
    let touchX = 0, touchY = 0;
    let swipeEnCours = false;

    function collecterImages(zone){
      return Array.from(zone.querySelectorAll('.diapo-item[data-type="image"] img, .pp-media[data-type="image"] img'));
    }

    function urlImage(img){
      return img.dataset.fullsrc || img.currentSrc || img.src;
    }

    function fermer(){
      vis.classList.remove('on');
      contenu.innerHTML = '';
      points.innerHTML = '';
      images = [];
      document.documentElement.style.overflow = '';
    }

    function afficher(i, direction){
      if (!images.length) return;
      index = (i + images.length) % images.length;
      const src = images[index];
      const g = document.createElement('img');
      g.src = urlImage(src);
      g.alt = src.alt || '';
      g.setAttribute('draggable', 'false');
      g.decoding = 'async';
      g.className = 'vis-image';
      if (direction) g.classList.add(direction === 'next' ? 'arrive-droite' : 'arrive-gauche');
      contenu.replaceChildren(g);

      points.innerHTML = images.map((_, n) => `<i${n === index ? ' class="on"' : ''}></i>`).join('');
      const multiple = images.length > 1;
      btnPrec.hidden = !multiple;
      btnSuiv.hidden = !multiple;
      points.hidden = !multiple;
    }

    function ouvrir(zone, img){
      images = collecterImages(zone);
      if (!images.length) return;
      const idx = images.indexOf(img);
      index = idx >= 0 ? idx : 0;
      afficher(index);
      vis.classList.add('on');
      document.documentElement.style.overflow = 'hidden';
    }

    function precedent(){ afficher(index - 1, 'prev'); }
    function suivant(){ afficher(index + 1, 'next'); }

    sources.forEach(zone => {
      zone.addEventListener('click', e => {
        if (window.__gallerySwipedUntil && Date.now() < window.__gallerySwipedUntil) {
          e.preventDefault();
          return;
        }
        if (e.target.closest('button')) return;
        const img = e.target.closest('.diapo-item[data-type="image"] img, .pp-media[data-type="image"] img');
        if (!img) return; // vidéos et vue 3D ne déclenchent pas la galerie photo
        ouvrir(zone, img);
      });
    });

    btnPrec.addEventListener('click', e => { e.stopPropagation(); precedent(); });
    btnSuiv.addEventListener('click', e => { e.stopPropagation(); suivant(); });

    vis.addEventListener('click', e => {
      if (e.target === vis || e.target.closest('.vis-fermer')) { fermer(); return; }
      if (e.target.classList.contains('vis-image') && !swipeEnCours) {
        e.target.classList.toggle('zoom');
      }
    });

    vis.addEventListener('touchstart', e => {
      if (!vis.classList.contains('on') || e.touches.length !== 1) return;
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
      swipeEnCours = false;
    }, {passive:true});

    vis.addEventListener('touchmove', e => {
      if (!vis.classList.contains('on') || e.touches.length !== 1) return;
      const dx = e.touches[0].clientX - touchX;
      const dy = e.touches[0].clientY - touchY;
      if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.15) {
        swipeEnCours = true;
        e.preventDefault();
      }
    }, {passive:false});

    vis.addEventListener('touchend', e => {
      if (!vis.classList.contains('on') || !e.changedTouches.length) return;
      const dx = e.changedTouches[0].clientX - touchX;
      const dy = e.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.15 && images.length > 1) {
        if (dx < 0) suivant(); else precedent();
        setTimeout(() => { swipeEnCours = false; }, 80);
      } else {
        setTimeout(() => { swipeEnCours = false; }, 0);
      }
    }, {passive:true});

    document.addEventListener('keydown', e => {
      if (!vis.classList.contains('on')) return;
      if (e.key === 'Escape') fermer();
      if (e.key === 'ArrowLeft' && images.length > 1) precedent();
      if (e.key === 'ArrowRight' && images.length > 1) suivant();
    });
  })();

  /* Newsletter */
})();